var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f1-step",class:{ active: _vm.active }},[_c('div',{staticClass:"f1-step-icon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:_vm.tab.icon})]),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.tab.title)))])])}
var staticRenderFns = []

export { render, staticRenderFns }